import { render } from "./PrivacyPolicyContent.vue?vue&type=template&id=552b14f2&scoped=true"
import script from "./PrivacyPolicyContent.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyContent.vue?vue&type=script&lang=js"

import "./PrivacyPolicyContent.vue?vue&type=style&index=0&id=552b14f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552b14f2"]])

export default __exports__